import Vue from 'vue'
import config from 'config'
import constants from './constants'
import router from '../router/index.js'

/**
 * 公共工具类
 */
"use strict";
let
	/**
	 * 保存用户信息
	 * @author 汪卫中
	 * @param userInfo: 用户信息。
	 */
	saveSessionUserInfo = (userInfo) => {
		if (userInfo) {
			let client_id = userInfo.client_id; // 客户号
			var full_name = '' //客户全称
			setInfoSStorage("client_id", client_id)

			let head_data = userInfo.head_data;
			setInfoSStorage("head_data", head_data)

			let invester_type = userInfo.invester_type; // 投资类型
			setInfoSStorage("invester_type", invester_type)

			let has_market_code9 = false
			let market = JSON.parse(head_data)
			if (market && market.length > 0) {
				for (let i in market) {
					if (market[i].market_code == config.global.market_code[8]) {
						has_market_code9 = true
					}
				}
			}


			setInfoSStorage('has_market_code9', has_market_code9, true)

			if (invester_type == constants.CUST_INVESTER_TYPE.ZY) {
				setInfoSStorage("filterfx", constants.MAX_SEARCHFX)
			}
			let userResult = userInfo["userResult"];//个人信息结果集
			if (userResult != null && userResult) {
				let result = JSON.parse(userResult['head_data'])
				if (result && result.length > 0) {
					let id_type = result[0]["id_type"];//证件类型
					var idtype = result[0]["idtype"];//证件类型 数值型
					let id_no = result[0]["id_no"];//证件号码
					let client_prop = result[0]["client_prop"];//个人用户或者是机构用户  0:个人 1:机构
					var id_no = result[0]["id_no"];//证件号码
					var sex = result[0]["sex"];//性别
					var client_prop = result[0]["client_prop"];//个人用户或者是机构用户  0:个人 1:机构
					var address = result[0]["address"];//地址
					var post_no = result[0]["post_no"];//邮编
					var risk_level_status = result[0]["risk_level_status"];
					var risk_level = result[0]["risk_level"];
					full_name = result[0]["full_name"];
					setInfoSStorage("id_type", id_type)
					setInfoSStorage("idtype", idtype)
					setInfoSStorage("id_no", id_no)
					setInfoSStorage("sex", sex);
					setInfoSStorage("client_prop", client_prop);
					setInfoSStorage("address", address);
					setInfoSStorage("post_no", post_no);
					setInfoSStorage("risk_level", risk_level);
					setInfoSStorage("risk_level_status", risk_level_status);

				}
			}
			let client_name = userInfo.client_name || userResult.client_name; // client_name

			setInfoSStorage("client_name", client_name)

			setInfoSStorage("full_name", full_name)

			let jsessionid = userInfo.jsessionid; // jsessionid
			setInfoSStorage("jsessionid", jsessionid)
		}
	},
	/**
	 * 清除用户信息
	 */
	clearSessionUserInfo = () => {
		sessionStorage.removeItem("client_id")
		sessionStorage.removeItem("head_data")
		sessionStorage.removeItem("invester_type")
		sessionStorage.removeItem("has_market_code9")
		sessionStorage.removeItem("filterfx")
		sessionStorage.removeItem("id_type")
		sessionStorage.removeItem("id_no")
		sessionStorage.removeItem("client_prop")
		sessionStorage.removeItem("client_name")
		sessionStorage.removeItem("jsessionid")
	},
	/**
	 * 保存信息到storage中
	 * @param key 键名称
	 * @param value 值
	 */
	setInfoSStorage = (key, value, boolean) => {
		if (key && (typeof(value) != "undefined")) {
			if (boolean) {
				let valueJSON = JSON.stringify({'value': value})
				sessionStorage.setItem(key, valueJSON)
			}
			else {
				sessionStorage.setItem(key, value)

			}
		}
	},

	/**
	 * 保存信息到storage中
	 * @param key 键名称
	 * @param value 值
	 */
	getInfoSStorage = (key, boolean) => {

		if (boolean) {
			let valueJSON = sessionStorage.getItem(key)
			if (valueJSON) {
				let value = JSON.parse(valueJSON)['value']
				return value
			}
			else {
				return null
			}

		}
		else {
			return sessionStorage.getItem(key)
		}

	},
	/**
	 * 处理会话失效
	 */
	filterLoginOut = () => {
		clearSessionUserInfo();
		let curPage = JSON.parse(sessionStorage.getItem("_curPage")) || {}
		let pagePath = curPage.path || '/'

		// 需要判断是否在客户端内，如果是则唤起登录
		if (window.qt) {
			router.push({path: "/"})
		}
		else {
			if (pagePath == '/login') {
				pagePath = ''
				router.push({path: "/login"})
			}
			else {
				router.push({path: "/login", query: {to: pagePath}})
			}
		}
		/*	   Vue.default.$confirm({
                   "title": "系统提示",
                   "content": "登录超时,是否重新登录?",
                   "confirmText": "登录",
                   "cancelText": "退出",
                   "onConfirm"() {
                       router.push({path: "/login",query: { to: pagePath }})
                   },
                   "onCancel"() {
                       router.push({ path: "/"})
                   }
               });*/
	}

const userSessionUtils = {
	saveSessionUserInfo: saveSessionUserInfo,//保存用户信息
	clearSessionUserInfo: clearSessionUserInfo,//清除用户信息
	filterLoginOut: filterLoginOut,//处理会话失效
	setInfoSStorage: setInfoSStorage,
	getInfoSStorage: getInfoSStorage,
};
export default userSessionUtils;



// WEBPACK FOOTER //
// ./src/common/userSessionUtils.js